import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable, Subject } from "rxjs";
import { AppConsts } from "@shared/app-consts";
import {
  AddBankAccountRequest,
  AddBankAccountResponse,
  DeleteBankAccountRequest,
  DeleteClientResponse,
  EditBankAccountRequest,
  EditBankAccountResponse,
  EInvoiceBankAccountDto,
  EInvoiceBankAccountListModel,
  ListEInvoiceBankAccountRequest,
} from "@shared/e-invoice";
import { BaseService } from "@services/base.service";

@Injectable({
  providedIn: "root",
})
export class EInvoiceBankAccountService extends BaseService {
  // Parité V1 : retypé Subject<void> (déclencheur sans valeur — RxJS 7 exige un argument sur next() sinon).
  RefreshSubject: Subject<void> = new Subject<void>();

  constructor(private http: HttpClient) {
    super();
  }

  list(
    request: ListEInvoiceBankAccountRequest
  ): Observable<EInvoiceBankAccountListModel> {
    let httpOptions = this.getHttpHeader(false, this.cleanEmpty(request));

    return this.http.get(
      AppConsts.API_SERVICE_URL + "ElectronicInvoiceBankAccount",
      httpOptions
    ) as Observable<EInvoiceBankAccountListModel>;
  }

  item(id: number): Observable<EInvoiceBankAccountDto> {
    let httpOptions = this.getHttpHeader(false);

    return this.http.get(
      AppConsts.API_SERVICE_URL + `ElectronicInvoiceBankAccount/${id}`,
      httpOptions
    ) as Observable<EInvoiceBankAccountDto>;
  }

  add(request: AddBankAccountRequest): Observable<AddBankAccountResponse> {
    let httpOptions = this.getHttpHeader(false);

    return this.http.post(
      AppConsts.API_SERVICE_URL + `ElectronicInvoiceBankAccount`,
      request,
      httpOptions
    ) as Observable<AddBankAccountResponse>;
  }

  edit(
    id: number,
    request: EditBankAccountRequest
  ): Observable<EditBankAccountResponse> {
    let httpOptions = this.getHttpHeader(false);

    return this.http.put(
      AppConsts.API_SERVICE_URL + `ElectronicInvoiceBankAccount/${id}`,
      request,
      httpOptions
    ) as Observable<EditBankAccountResponse>;
  }

  delete(
    id: number,
    request: DeleteBankAccountRequest
  ): Observable<DeleteClientResponse> {
    let httpOptions = this.getHttpHeader(false, this.cleanEmpty(request));

    return this.http.delete(
      AppConsts.API_SERVICE_URL + `ElectronicInvoiceBankAccount/${id}`,
      httpOptions
    ) as Observable<DeleteClientResponse>;
  }
}
